module.exports = __webpack_public_path__ + "img/1_2.34ded679.jpg";